export default function(exc) {
    this.fields.take = exc.currency.take.fields.take.map(f => Object.assign({}, f, { value: "" }));
    this.fields.give = exc.currency.give.fields.give.map(f => Object.assign({}, f, { value: "" }));
}
